import React, { useEffect } from "react";
import HomeContent from "../../components/home/content";
import RootLayout from "../layout";
import { updateAllLayouts } from "@noriginmedia/norigin-spatial-navigation";
import { useDispatch } from "react-redux";
import { startLoading, stopLoading } from "../../redux/Slices/loading.slice";
import PageLayout from "../../components/layout/PageLayout";
import { useShowcaseCacheWithConfig } from "../../utils/hooks/useShowcaseCache";

const MovieHome = () => {
  const dispatch = useDispatch();

  const { data: homeData, loading } = useShowcaseCacheWithConfig({
    cacheKey: "movie",
    configKey: "movie",
    versionTitle: "film",
  });

  // Handle loading state for sidebar
  useEffect(() => {
    if (loading) {
      dispatch(startLoading("در حال بارگذاری فیلم‌ها..."));
    } else {
      dispatch(stopLoading());
      updateAllLayouts();
    }
  }, [loading, dispatch]);

  return (
    <RootLayout>
      <PageLayout loading={loading} skeletonType="showcase">
        {homeData && <HomeContent showCaseData={homeData} isShowcasePage={true} contentKind="movie" />}
      </PageLayout>
    </RootLayout>
  );
};

export default MovieHome;

